import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { isNotificationBroadcastJobModuleFailedPayload } from "@/entities/notification-broadcast";
import { useInvalidateNotificationsDatabase } from "@/entities/notifications-database";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { notifyJobModuleFailed } from "./job-module-action-failed.helper";

export const useJobModuleActionFailed = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState } = useUpdateJobModuleStateQueryData();
  const { setFailedState } = useAsyncActions();
  const { invalidateNotifications } = useInvalidateNotificationsDatabase();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();
  const runAction = (payload: EventBusPayload) => {
    if (!isNotificationBroadcastJobModuleFailedPayload(payload)) return;
    if (isBroadcastNotificationEnabled(payload.job_module.module_tag)) {
      const title = t("broadcast:jobModuleFailed", {
        moduleName: payload.job_module.module_name,
      });
      notifyJobModuleFailed({ notify, title, payload });
    }

    setFailedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Failed");

    invalidateNotifications("*");
  };

  return { runAction };
};
